import React, { Component } from 'react';
import _ from 'lodash';
import { Divider, Form, Grid, TextArea, Loader } from 'semantic-ui-react';
import { getAudiences } from '../../fbApi/Audience';

import {
  generateWebsiteAudience,
  generateVideoAudience,
  generateCanvasAudience,
  createLookalikeAudience
} from '../AudienceBuilder/AudienceCreator';

import './../AudienceBuilder/AudienceBuilder.css';

class PackageLaunchLookalikeMaker extends Component {
  state = {
    processing: false,
    processingMessage: '',
    message: '',
    logText: '',
    retargetingAudiences: '',
    lookalikeAudiences: ''
  };

  componentDidUpdate(prevProps) {
    const { launchingPackage: prevLaunchPackage } = prevProps;
    const { launchingPackage } = this.props;
    if (!prevLaunchPackage && launchingPackage) {
      this.createNewAudiences();
    }
  }

  createNewAudiences = () => {
    const { token, accountId, setBuildingAudiences } = this.props;
    setBuildingAudiences(true);
    this.setState(
      {
        ...this.state,
        processing: true,
        logText: '',
        processingMessage: 'Creating Retargetting Audience...'
      },
      async () => {
        const { packageToLaunch } = this.props;

        const createRetargetingAudiencesRes = await Promise.all(
          packageToLaunch.campaigns.map(async (campaign) => {
            const generateAudiencePromise = await this.generateAudienceByType(
              'Website',
              campaign
            );
            return Promise.resolve(generateAudiencePromise);
          })
        );

        this.setState(
          (prevState) => ({
            ...prevState,
            processing: true,
            processingMessage: 'Creating Lookalike Audiences...',
            retargetingAudiences: createRetargetingAudiencesRes
          }),
          async () => {
            try {
              const audienceOptions = await this.getAudienceOptions();

              const createLookalikeAudiencesRes = await Promise.all(
                this.state.retargetingAudiences.map(
                  async (retargetingAudienceObj) => {
                    const { logText } = this.state;
                    let finalLogText = logText;
                    let lookalikeAudienceId = '';
                    let foundAudienceName = '';
                    const {
                      campaignId,
                      isHecCampaign,
                      retargetingAudienceId
                    } = retargetingAudienceObj;

                    const foundOption = audienceOptions.find(
                      (option) => option.id === retargetingAudienceId
                    );

                    if (foundOption) {
                      const { name, id } = foundOption;
                      foundAudienceName = name;
                      const audienceData = {
                        origin_audience_id: id,
                        name: `${name} - Lookalike`,
                        lookalike_spec: {
                          ratio: 0.01,
                          country: 'US'
                        },
                        accountId,
                        isHecCampaign
                      };

                      const createLookalikeRes = await createLookalikeAudience(
                        audienceData,
                        token
                      );

                      lookalikeAudienceId = createLookalikeRes.id || '';

                      finalLogText = this.returnLogText(
                        createLookalikeRes,
                        'Lookalike'
                      );

                      this.setState({ ...this.state, logText: finalLogText });
                    }

                    return Promise.resolve({
                      name: `${foundAudienceName} - Lookalike`,
                      lookalikeAudienceId,
                      isHecCampaign,
                      campaignId
                    });
                  }
                )
              );

              this.setState(
                (prevState) => ({
                  ...prevState,
                  lookalikeAudiences: createLookalikeAudiencesRes,
                  processingMessage: 'Duplicating Adsets...'
                }),
                async () => {
                  const newAudienceOptions = await this.getAudienceOptions();

                  const foundLookalikeOptions = this.state.lookalikeAudiences.map(
                    (obj) => {
                      return {
                        campaignId: obj.campaignId,
                        lookalikeAudience: newAudienceOptions.find(
                          (option) => option.id === obj.lookalikeAudienceId
                        )
                      };
                    }
                  );

                  const foundRetargetingOptions = this.state.retargetingAudiences.map(
                    (obj) => {
                      return {
                        campaignId: obj.campaignId,
                        retargetingAudience: newAudienceOptions.find(
                          (option) => option.id === obj.retargetingAudienceId
                        )
                      };
                    }
                  );

                  this.setState(
                    {
                      ...this.state,
                      processingMessage: 'Done',
                      processing: false
                    },
                    () => {
                      setBuildingAudiences(false, {
                        retargetingAudiences: foundRetargetingOptions || null,
                        lookalikeAudiences: foundLookalikeOptions || null
                      });
                    }
                  );
                }
              );
            } catch (error) {
              const newLogText = `${this.state.logText}\n${error}`;
              this.setState(
                {
                  ...this.state,
                  logText: newLogText,
                  procesing: false
                },
                () => {
                  setBuildingAudiences(false);
                }
              );
            }
          }
        );
      }
    );
  };

  getAudienceOptions = async () => {
    const { accountId, token } = this.props;
    const audiencesResult = await getAudiences(accountId, token);
    const audiences = audiencesResult[0].data.concat(audiencesResult[1].data);

    const audienceOptions = _.sortBy(
      _.map(audiences, (op, index) => ({
        key: index,
        id: op.id,
        name: op.name
      })),
      'text'
    );

    return audienceOptions;
  };

  generateAudienceByType = async (type, campaign) => {
    const { pageObject, pixel, accountId, token } = this.props;
    const { pageId } = pageObject;

    if (!pageId && type !== 'Website') {
      this.setState({ ...this.state, message: 'You must select a page' });
      return Promise.resolve({});
    }

    const data = {
      pixel,
      accountId,
      token,
      pageId
    };

    let resultAudience;

    switch (type) {
      case 'Canvas':
        resultAudience = await generateCanvasAudience(data);
        break;
      case 'Cinemagraph':
      case 'Video':
        resultAudience = await generateVideoAudience(data);
        break;
      case 'Website':
        delete data.pageId;
        resultAudience = await generateWebsiteAudience(data);
        break;
      default:
        resultAudience = {};
        break;
    }

    const finalLogText = this.returnLogText(resultAudience, type);

    this.setState({
      ...this.state,
      logText: finalLogText
    });

    const returnObj = {
      retargetingAudienceId: resultAudience ? resultAudience.id : ''
    };

    if (campaign) {
      returnObj.isHecCampaign = campaign.is_hec_campaign;
      returnObj.campaignId = campaign.id;
    }

    return Promise.resolve(returnObj);
  };

  returnLogText = (audienceResult, type) => {
    const { id: audienceId, error } = audienceResult;
    const { logText } = this.state;
    let finalLogText = logText;

    if (audienceId) {
      finalLogText = `${logText} ${type} Audience - CREATED with ID: ${audienceId}\n`;
    } else {
      finalLogText = `${logText} Lookalike Audience - ERROR: ${error.message}\n`;
    }

    return finalLogText;
  };

  render() {
    const { pixel, accountId, pageObject } = this.props;
    const { message, processing, logText, processingMessage } = this.state;
    return (
      <div className="form-container">
        <Grid>
          <Grid.Row columns={4}>
            <Grid.Column />
            <Grid.Column>
              <p>Pixel</p>
              <Form.Input
                className="input-form"
                type="text"
                name="pixel"
                disabled
                value={pixel}
              />
            </Grid.Column>
            <Grid.Column>
              <p>Account ID</p>
              <Form.Input
                className="input-form"
                type="text"
                name="account"
                disabled
                value={accountId}
              />
            </Grid.Column>
            <Grid.Column>
              <p>Page ID</p>
              <Form.Input
                className="input-form"
                type="text"
                name="account"
                disabled
                value={pageObject.pageIdText}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <Divider hidden />
        {message ? (
          <div>
            <span>{message}</span>
          </div>
        ) : null}
        {processing ? (
          <div className="processing-container">
            <span>
              {' '}
              <Loader inline className="active" /> {processingMessage}
            </span>
          </div>
        ) : null}
        <Divider hidden />
        <TextArea placeholder="Debug Log" disabled rows="8" value={logText} />
      </div>
    );
  }
}

export default PackageLaunchLookalikeMaker;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/PackageLaunchLookalikeMaker.js